<template>
  <div class="selfrun">
      <select-tab 
        ref='tabinit' 
        :changeInfo.sync="changeInfo"
        @filterEvent="filter">
      </select-tab>
    <!-- 活动头图 -->
    <div class="banner">
      <img src="https://img-gdcdn.ponhu.cn/truetrueyouxuan.jpg" alt="">
    </div>
    <div class="content">
      <p>共为您找到{{total}}个商品</p>
      <van-list v-model="loading" :finished="finished" finished-text="已加载全部商品" @load="onReachBottom" :offset="100">
        <filter-good v-if="!isEmpty" :list.sync="goodsList"></filter-good>
        <emptyData v-if="isEmpty" message="暂无商品"></emptyData>
      </van-list>
      <van-divider v-if="isBottom" :style="{ color: '#ccc', borderColor: '#ccc', padding: '0 90px' }">已经到底了</van-divider>
    </div>
  </div>
</template>
<script>
import SelectTab from '@/components/business/Find_Select_Tab'
import FilterGood from '@/components/business/FilterGood'
import EmptyData from '@/components/business/EmptyData'
import { getFindSearchKey,getActivityDetails } from '@/api/good'
import { getLocalStorage } from "@/utils";
export default {
  name : 'selfrun',
  components : {FilterGood,EmptyData,SelectTab},
  data(){
    return{
      criteria: {
        queryWords : '',
        usersId : '',
        isSelf : 1,
        isRecommend : '',
        isNew : 1,
        categoryId_first : '',
        categoryId_second : '',
        brandsId : '',
        sort : '',
        prices : '',
        renqunType : '',
        colorId : '',
        pageSize : 10,
        currentPage : 1,
      },
      goodsList : [],
      isEmpty : false,
      topicCover: '',
      page: 1,
      pagecount: 10,
      pageTotal: 0,
      total: 0,
      topicDescribe : '',
      loading: false,
      finished: false,
      isEmpty: false,
      isBottom : false,
      changeInfo:{}
    }
  },
  created(){
    this.getData(true)
  },  
  methods:{
    // 获取数据
    getData (refresh) {
      this.Loading = false;
      this.isEmpty = false;
      this.isBottom = false
      this.criteria.pageSize = 20
      this.criteria.currentPage = this.page
      getFindSearchKey(this.criteria).then(res => {
        console.log(res)
        console.log(this.criteria)
        let data = res.data.resultEntity 
        if (refresh) {
          this.goodsList = data.resultList || []
        } else {
          this.goodsList = [...this.goodsList, ...data.resultList]
        }
        //总数量
        this.total = data.totalRecord
        //总页数
        this.pageTotal = data.totalPage
        if (this.goodsList.length === 0) {
          this.total = 0
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.loading = false
      }).catch(error => {
        this.$toast(error)
      })
    },
      // 加载更多
    onReachBottom () {
      this.loading = true
      console.log(this.page)
      if(this.goodsList.length > 0) {
        if (this.page > this.pageTotal) { // 已经到底部
          this.finished = true
          this.isBottom = true
        }
      }
      this.page++
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    filter(obj){
      this.criteria = obj
      console.log(this.criteria)
      this.page = 1
      this.getData(true)
    }
  }
}
</script>
<style lang="less" scoped>
.selfrun{
  .banner{
    width: 100%;
    height: 450px;
    position: relative;
    top: 1.2rem;
  }
  .content{
    padding:0 24px;
    margin-top: 1.5rem;
    p{
      padding-left: 24px;
      font-size:20px;
      font-weight:400;
      color:rgba(153,153,153,1);
    }
  }
}
</style>